import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FALLBACK = [
  { id: "f1", author: "Eleanor M.", rating: 5, text: "Best Tandoori Lamb Chops in town.", source: "Google", date: "2025-09-14" },
  { id: "f2", author: "James R.", rating: 5, text: "Delicious and entirely different food.", source: "TheFork", date: "2025-10-02" },
];

export default function useReviews() {
  const [reviews, setReviews] = useState(FALLBACK);

  useEffect(() => {
    let mounted = true;
    axios.get(`${API}/reviews`).then((res) => {
      if (mounted && Array.isArray(res.data)) setReviews(res.data);
    }).catch(() => {});
    return () => { mounted = false; };
  }, []);

  return reviews;
}
